import { Box, Stack, useElementBreakpoints } from "@compass/core";
import { CustomFilters } from "components";
import { CustomEntityOption } from "components/common/CustomFilters/CustomFilter";
import { CustomFilterEntity, LkStudentEnrollmentDisplayFieldId, LkStudentTabId, StudentEnrollmentFilter as StudentEnrollmentFilterModel, StudentEnrollmentFilterResource, StudentEnrollmentListFilter, StudentEnrollmentListResource, StudentFilterResource } from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { StudentEnrollmentFilterAccordion } from "./StudentEnrollmentFilterAccordion";
import { StudentDemographicsFilterAccordion } from "../students/StudentDemographicsFilterAccordion";
import { FilterAccordion } from "components/common/CustomFilters/FilterAccordion";

export const StudentEnrollmentFilter = (props: {
  resource?: StudentEnrollmentListResource | null;
  filter: StudentEnrollmentListFilter;
  setFilter: (filter: StudentEnrollmentListFilter) => void;
}) => {
  const displayFields = props.resource?.displayFields || [];
  const [demographicResource, setDemographicResource] = useState<StudentFilterResource>({} as StudentFilterResource);
  const [resource, setResource] = useState<StudentEnrollmentFilterResource>({});
  const properties = resource.properties || [];
  const { breakpointsRef, largeFieldBreakpoints } = useElementBreakpoints();
  const studentTabIds = resource.studentTabs?.map((x) => x.id);

  const schoolDisplayField = displayFields.find((x) => x.id === LkStudentEnrollmentDisplayFieldId.School);

  const entityOptions: CustomEntityOption[] = [
    { EntityType: CustomFilterEntity.Student, EntityName: "Demographics" },
    { EntityType: CustomFilterEntity.StudentEnrollment, EntityName: "Enrollments" },
    // { EntityType: CustomFilterEntity.StudentAbsence, EntityName: "Absences" },
    // { EntityType: CustomFilterEntity.StudentDiploma, EntityName: "Diploma" },
    // { EntityType: CustomFilterEntity.StudentGpa, EntityName: "GPA" },
    // { EntityType: CustomFilterEntity.StudentGrades, EntityName: "Grades" },
    // { EntityType: CustomFilterEntity.StudentPostHighSchool, EntityName: "Post HS Plans" },
    // { EntityType: CustomFilterEntity.StudentScholarship, EntityName: "Scholarship" },
    // { EntityType: CustomFilterEntity.StudentTest, EntityName: "Test Scores" },


  ];

      if (studentTabIds?.includes(LkStudentTabId.Absence)){
      entityOptions.push({ EntityType: CustomFilterEntity.StudentAbsence, EntityName: "Absences" });
    }
      if (studentTabIds?.includes(LkStudentTabId.Diploma)){
      entityOptions.push({ EntityType: CustomFilterEntity.StudentDiploma, EntityName: "Diploma" });
    }
      if (studentTabIds?.includes(LkStudentTabId.Gpa)) {
      entityOptions.push({ EntityType: CustomFilterEntity.StudentGpa, EntityName: "GPA" });
    }
    if (studentTabIds?.includes(LkStudentTabId.Grade)) {
      entityOptions.push({ EntityType: CustomFilterEntity.StudentGrades, EntityName: "Grades" });
    }
      if (studentTabIds?.includes(LkStudentTabId.PostHs)) {
      entityOptions.push({ EntityType: CustomFilterEntity.StudentPostHighSchool, EntityName: "Post HS Plans" });
    }
    if (studentTabIds?.includes(LkStudentTabId.Scholarship)) {
      entityOptions.push({ EntityType: CustomFilterEntity.StudentScholarship, EntityName: "Scholarship" });
    }
      if (studentTabIds?.includes(LkStudentTabId.Test)) {
      entityOptions.push({ EntityType: CustomFilterEntity.StudentTest, EntityName: "Test Scores" });
    }

  useEffect(() => {
    ApiService.students.getFilterResource().then((response) => {
      setDemographicResource(response);
    });

    ApiService.studentEnrollments.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  // const schoolYearsField = () => {
  //   const propertyName = pn<StudentEnrollmentFilterModel>("schoolYears");
  //   const property = properties.find((x) => x.propertyName === propertyName);

  //   return (
  //     <Select
  //       modelProperty={property}
  //       multiple
  //       value={resource.schoolYears?.filter((x) => props.filter.schoolYears?.includes(x.id))}
  //       options={resource.schoolYears}
  //       getOptionLabel={option => option.name}
  //       onChange={(e, values) =>
  //         props.setFilter(
  //           produce(props.filter, (draft) => {
  //             draft.schoolYears = values.map((x) => x.id);
  //           })
  //         )
  //       }
  //     />
  //   );
  // };

  // const schoolsField = () => {
  //   const propertyName = pn<StudentEnrollmentFilterModel>("schoolIds");
  //   const property = properties.find((x) => x.propertyName === propertyName);

  //   return (
  //     <Select
  //       modelProperty={property}
  //       multiple
  //       value={resource.schools?.filter((x) => props.filter.schoolIds?.includes(x.id))}
  //       options={resource.schools}
  //       getOptionLabel={option => option.name}
  //       onChange={(e, values) =>
  //         props.setFilter(
  //           produce(props.filter, (draft) => {
  //             draft.schoolIds = values.map((x) => x.id);
  //           })
  //         )
  //       }
  //     />
  //   );
  // };

  return (
    <Stack ref={breakpointsRef} spacing="lg" padding={2}>
      <CustomFilters
        allowedEntityTypes={entityOptions}
        filters={props.filter.customFilters}
        setFilters={(filters) =>
          props.setFilter(
            produce(props.filter, (draft) => {
              draft.customFilters = filters;
            })
          )
        }
        properties={resource.customFilterProperties}
      />


      <Box>
        <FilterAccordion title="" defaultExpanded>
          <StudentDemographicsFilterAccordion
            resource={demographicResource}
            filter={props.filter.studentFilter!}
            setFilter={(subFilter) =>
              props.setFilter(
                produce(props.filter, (draft) => {
                  draft.studentFilter = subFilter;
                })
              )
            }
          />
        </FilterAccordion>
      </Box>
      {/* <Box>
        <FilterAccordion title="Enrollment">
          <StudentEnrollmentFilterAccordion
            resource={resource}
            filter={props.filter.enrollmentFilter!}
            setFilter={(subFilter) =>
              props.setFilter(
                produce(props.filter, (draft) => {
                  draft.enrollmentFilter = subFilter;
                })
              )
            }
          />
        </FilterAccordion>
      </Box> */}
    </Stack>
  );
};
